import { LegendItem } from '@/components/atoms';
import { LEGEND_LABELS } from '@/constants/timeline';
import type { ColorScheme } from '@/types/timeline';

export interface TimelineLegendProps {
  /** Active color scheme for segments */
  colors: ColorScheme;
  /** Optional additional className */
  className?: string;
}

/**
 * Timeline legend molecule - displays all segment types with their colors
 *
 * Shows a horizontal legend explaining what each timeline segment color represents.
 */
export function TimelineLegend({ colors, className = '' }: TimelineLegendProps) {
  return (
    <div
      className={`
        flex flex-wrap items-center gap-4 text-xs
        ${className}
      `}
    >
      {LEGEND_LABELS.map((item) => (
        <LegendItem key={item.key} color={colors[item.key]} label={item.label} />
      ))}
    </div>
  );
}
